import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';
import { isString } from 'util';

import { AppState } from '../../reducers';

import {
    setChannelUserIdAction,
    setUserPhoneAction,
    setUserCodeAction,
    setChannelIdAction,
    setUserLangAction
} from '../../actions/user';
import { registrationSendCodeAction, resetSendCodeRegistrationAction } from '../../actions/Registration/registration';

import { SendCodeView } from '../RegistrationAuthorization/SendCodeView';
import i18next from 'i18next';
import firebaseAuthObject from '../../lib/firebaseAuthObject';
import * as firebase from 'firebase';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface RegistrationSendCodeContainerProps extends Props<RegistrationSendCodeContainer> {
    sendCodeRegistration: boolean;
    loadingSendCodeRegistration: boolean;
    errorSendCodeRegistration: string | {
        error: string;
        message: {
            ru: string;
        };
        code: number;
    } | null;

    lang: string;
    phone: string;
    code: string;

    channelUserId: string;
    channelId: string;
    isFirebaseAuth: boolean;
    registration: boolean;
}

interface RegistrationSendCodeContainerDispatch extends Props<RegistrationSendCodeContainer> {
    setLang: (lang: string) => any;
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
    setCode: (code: string) => any;
    onRegistrationSendCode: (body: any) => any;
    resetSendCodeRegistration: () => any;
}

function mapProps(state: AppState, props: RegistrationSendCodeContainerProps): RegistrationSendCodeContainerProps {
    return {
        sendCodeRegistration: state.registrationState.sendCodeRegistration,
        loadingSendCodeRegistration: state.registrationState.loadingSendCodeRegistration,
        errorSendCodeRegistration: state.registrationState.errorSendCodeRegistration,

        lang: state.userState.lang,
        phone: state.userState.phone,
        code: state.userState.code,

        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
        isFirebaseAuth: state.registrationState.isFirebaseAuth,
        registration: state.registrationState.registration
    };
}

function mapDispatch(dispatch: Dispatch<any>): RegistrationSendCodeContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        setCode: (code: string) => dispatch(setUserCodeAction(code)),
        onRegistrationSendCode: (body: any) =>
            dispatch(registrationSendCodeAction(body)),
        resetSendCodeRegistration: () => dispatch(resetSendCodeRegistrationAction()),
    };
}

interface RegistrationSendCodeContainerState {
    firebaseAuth: any | undefined;
    verifier: any | undefined;
    confirmation: any | undefined;
    isVerifierChecked: boolean;
    authError: string;
    loading: boolean;
}

const bankNumber = '+7 499 753 10 65';

type AllProps = RegistrationSendCodeContainerProps & RegistrationSendCodeContainerDispatch & RouteProps;

class RegistrationSendCodeContainer extends React.Component<AllProps, RegistrationSendCodeContainerState> {

    state: RegistrationSendCodeContainerState = {
        firebaseAuth: undefined,
        verifier: undefined,
        confirmation: undefined,
        isVerifierChecked: false,
        authError: '',
        loading: false
    };

    private MAXIMUM_ATTEMPTS_EXCEEDED = i18next.t('maximum_attempts_exceeded', { phone: `<a href='tel:${bankNumber}'>${bankNumber}</a>` });
    private WRONG_CODE_MSG = i18next.t('wrong_code_message');
    private CODE_EXPIRED_MSG = i18next.t('code_expired');

    CONNECT_ERROR = (status: number) => i18next.t('error_contact_konsierge', {status}) + i18next.t('or_reload_page');

    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, lang, isFirebaseAuth, registration } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channel = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channel) {
                setChannelId(channel);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
            if (!registration) {
                history.push(`/authorization?channel_id=${channel}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
                return;
            }
            if (isFirebaseAuth) {
                this.setState({loading: true});
                await this.connectFirebase();
                setTimeout(() => {
                    this.setState({authError: this.CODE_EXPIRED_MSG});
                    setTimeout(() => history.push(`/authorization?channel_id=${channel}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`), 5000);
                }, 300000);
            }
        }
    }

    async componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<RegistrationSendCodeContainerState>, snapshot?: any) {
        const { phone, isFirebaseAuth } = this.props;
        const { firebaseAuth, verifier, confirmation } = this.state;
        if (isFirebaseAuth && !prevProps.isFirebaseAuth) {
            this.setState({loading: true});
            this.connectFirebase();
        }
        if (firebaseAuth && !prevState.firebaseAuth) {
            this.initializeRecaptcha();
        }
        /*if (verifier && verifier !== prevState.verifier) {
            setTimeout(() => this.verifyNumber(), 5000);
        }*/
        if (verifier && verifier !== prevState.verifier
            && firebaseAuth && phone && verifier) {
            this.signInFirebase();
        }
        if (confirmation && confirmation !== prevState.confirmation) {
            this.setState({loading: false});
        }
    }

    componentWillUnmount() {
        const {resetSendCodeRegistration} = this.props;
        resetSendCodeRegistration();
    }

    componentWillReceiveProps(nextProps: RegistrationSendCodeContainerProps & RegistrationSendCodeContainerDispatch & RouteProps) {
        const { sendCodeRegistration, history, phone, channelUserId, channelId, lang } = nextProps;
        if (sendCodeRegistration && (sendCodeRegistration !== this.props.sendCodeRegistration)) {
            history.push(`/registration/success?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
        }
    }

    connectFirebase = async () => {
        try {
            const firebaseAuth = firebase.initializeApp(firebaseAuthObject);
            this.setState({firebaseAuth});
        } catch (e) {
            console.log(e);
            const firebaseAuth = firebase.app();
            this.setState({firebaseAuth});
        } finally {
            firebase.auth().useDeviceLanguage();
        }
    }

    initializeRecaptcha = async () => {
        try {
            var applicationVerifier = new firebase.auth.RecaptchaVerifier(
                'recaptcha-container', {
                    size: 'invisible',
                    callback: () => {
                        this.setState({isVerifierChecked: true});
                    }
                });
            await applicationVerifier.verify();
            this.setState({verifier: applicationVerifier});
        } catch (e) {
            console.log(e);
            this.setState({loading: false, authError: this.CONNECT_ERROR(405)});
        }
    }

    verifyNumber = async () => {
        const { phone } = this.props;
        const { verifier } = this.state;
        try {
            const provider = new firebase.auth.PhoneAuthProvider();
            setTimeout(() => provider.verifyPhoneNumber(`+${phone}`, verifier)
                .then(() => {
                    console.log('ok number');
                }), 1000);
        } catch (e) {
            console.log(e);
            this.setState({loading: false, authError: this.CONNECT_ERROR(409)});
        }
    }

    signInFirebase = () => {
        const { phone } = this.props;
        const { firebaseAuth, verifier } = this.state;
        if (firebaseAuth && verifier && phone) {
            firebase.auth().signInWithPhoneNumber(`+${phone}`, verifier)
                .then((confirmationResult) => {
                    if (!confirmationResult) {
                        this.setState({authError: this.CONNECT_ERROR(401)});
                    } else {
                        this.setState({confirmation: confirmationResult});
                    }
                }).catch((error) => {
                console.log(error);
                this.setState({authError: this.CONNECT_ERROR(401)});
            });
        } else {
            console.log('unset confirmation');
            this.setState({confirmation: undefined, authError: this.CONNECT_ERROR(402)});
        }
    }

    onFirebaseSendCode = (code: string) => {
        const { phone, channelUserId, onRegistrationSendCode } = this.props;
        const { confirmation } = this.state;
        if (!confirmation) {
            alert(this.CONNECT_ERROR(400));
            return;
        }
        confirmation!.confirm(code).then((result) => {
            // User signed in successfully.
            const user: any = result.user;
            console.log('success');
            onRegistrationSendCode(JSON.stringify({
                userId: channelUserId,
                phone,
                firebaseToken: user.ma || user._lat,
                services: (localStorage.getItem('re-authorization')) ? localStorage.getItem('re-authorization') === 'dif_msngr' : false
            }));
        }).catch(() => {
            this.setState({authError: this.WRONG_CODE_MSG});
        });
    }

    onSendCode = (code: string) => {
        const { isFirebaseAuth, phone, channelUserId, onRegistrationSendCode } = this.props;
        if (isFirebaseAuth) {
            this.onFirebaseSendCode(code);
        } else {
            onRegistrationSendCode(JSON.stringify({
                userId: channelUserId,
                phone,
                code
            }));
        }
    }

    render() {
        document.title = i18next.t('registration');
        const { phone, code, setCode, channelUserId, channelId, lang, isFirebaseAuth } = this.props;
        const { loadingSendCodeRegistration, errorSendCodeRegistration, history } = this.props;
        const { authError, loading } = this.state;
        let error = '';

        if (authError) {
            error = authError;
        } else if (errorSendCodeRegistration) {
            if (isString(errorSendCodeRegistration)) {
                error = errorSendCodeRegistration;
            } else {
                if (errorSendCodeRegistration.code === 10 || errorSendCodeRegistration.code === 12) {
                    history.push(`/registration?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&error=${this.MAXIMUM_ATTEMPTS_EXCEEDED}&lang=${lang}`);
                }
                if (errorSendCodeRegistration.code === 11) {
                    error = this.WRONG_CODE_MSG;
                }
            }
        }

        return (
            <SendCodeView
                channelId={channelId}
                name={i18next.t('registration')}
                code={code}
                setCode={setCode}
                onSendCode={(newCode: string) => this.onSendCode(newCode)}
                error={error}
                codeLength={isFirebaseAuth ? 6 : 4}
                loading={loadingSendCodeRegistration || loading}
                isFirebaseAuth={isFirebaseAuth}
            />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(RegistrationSendCodeContainer));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationSendCodeContainer.tsx